export default "__VITE_ASSET__CaTPH1Al__"